import {useApp} from '../../../contexts/AppContext';
import {useEffect, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {Link, useLocation, useSearchParams} from 'react-router-dom';
import {getMyEvents} from '../../../api';
import {useCustomDialog} from '../../../contexts/CustomDialogContext';
import DBDPullDown from '../../atoms/DBDPullDown';
import moment from 'moment';
import './style.scss';

const ITEMS_PER_PAGE = 9;

const Page = styled.div`
  padding-top: 43px;
  @media ${config.layout.wide} {
    padding-top: 75px;
  }
`;

export const PageFeatureTitle = styled.div`
  height: 140px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  position: relative;
  @media ${config.layout.wide} {
    height: 142px;
  }

  h2 {
    position: absolute;
    left: 0;
    top: 21px;
    font-size: 30px;
    font-weight: bold;
    line-height: 39px;
    @media ${config.layout.wide} {
      line-height: 53px;
      font-size: 40px;
    }
  }

  div {
    height: 79px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    @media ${config.layout.wide} {
      height: 70px;
    }

    span {
      font-size: 14px;
      font-weight: bold;
      line-height: 19px;
    }
  }
`;

const ListTopArea = styled.div`
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > h3 {
    font-size: 16px;
    font-weight: bold;
  }

  @media ${config.layout.wide} {
    height: 100px;
  }
`;

const PlaylistsArea = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  margin-bottom: 60px;
  @media ${config.layout.wide} {
    gap: 50px 20px;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 80px;
  }

  & > .PlaylistItemLink {
    color: #000000;
    text-decoration: none;
    display: block;
    background-color: #fff;
    width: 100%;
    border-radius: 6px;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.05));
    padding: 30px 50px 30px 20px;
    transition: filter 0.15s linear, transform 0.15s ease-out;
    transform: none;
    @media ${config.layout.wide} {
      padding: 30px 20px 46px 20px;
      width: calc((100% - 40px) / 3);
    }

    &:hover {
      transform: translateY(-10px);
      filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.05));
    }

    position: relative;

    &:after {
      content: "";
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='15.602' viewBox='0 0 9 15.602'%3E%3Cpath id='パス_44' data-name='パス 44' d='M1.2,0,0,1.2,6.6,7.8,0,14.4l1.2,1.2L9,7.8Z' transform='translate(0 0)' fill='%23525252'/%3E%3C/svg%3E%0A");
      display: block;
      width: 9px;
      height: 16px;
      position: absolute;
      top: 50%;
      margin-top: -8px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 9px 16px;
      right: 20px;
      @media ${config.layout.wide} {
        top: initial;
        bottom: 20px;
      }
    }
  }
`;

const PlaylistItemDOW = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  white-space: pre;
`;
const PlaylistItemDate = styled.div`
  margin-top: 3px;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  white-space: pre;
`;

const PlaylistRoomLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  margin-top: 23px;
`;

const PlaylistRoom = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  margin-top: 10px;
  overflow-wrap: break-word;
`;

const PagerArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const NotFoundMessage = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const NoTracksLabel = styled.div`
  height: 24px;
  background-color: #000000;
  color: #fff;
  display: inline-block;
  font-weight: bold;
  font-size: 14px;
  height: 24px;
  line-height: 25px;
  border-radius: 2px;
  padding: 0 10px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

function PlaylistsPagenation({data, query}) {
  let pageCount = 0;
  if (data.total) {
    pageCount = Math.ceil(data.total / ITEMS_PER_PAGE);
  }
  let currentPage = query.page;
  if (!pageCount || currentPage < 1 || pageCount < currentPage) {
    return '';
  }

  let hasPrev = currentPage > 1;
  let hasNext = currentPage < pageCount;

  let hasPrevDots = pageCount >= 4 && currentPage >= 3;
  let hasNextDots = pageCount >= 4 && currentPage <= pageCount - 2;
  let linkStartPage = Math.max(
      currentPage - (currentPage == pageCount ? 2 : 1),
      1,
  );
  let linkEndPage = Math.min(linkStartPage + 2, pageCount);

  return (
      <PagerArea className="pager-area">
        {hasPrev
            ? (() => {
              let params = new URLSearchParams(query);
              params.set('page', currentPage - 1);
              return (
                  <Link
                      to={`/playlists/?${params.toString()}`}
                      className="prev"
                  ></Link>
              );
            })()
            : ''}

        {hasPrevDots ? <div className="dots">…</div> : ''}
        {[...Array(linkEndPage - linkStartPage + 1)].map((_, i) => {
          let params = new URLSearchParams(query);
          let p = i + linkStartPage;
          params.set('page', p);
          return (
              <Link
                  to={`/playlists/?${params.toString()}`}
                  key={i}
                  className={`number ${currentPage == p ? 'current' : ''}`}
              >
                {p}
              </Link>
          );
        })}
        {hasNextDots ? <div className="dots">…</div> : ''}
        {hasNext
            ? (() => {
              let params = new URLSearchParams(query);
              params.set('page', currentPage + 1);
              return (
                  <Link
                      to={`/playlists/?${params.toString()}`}
                      className="next"
                  ></Link>
              );
            })()
            : ''}
      </PagerArea>
  );
}

function PlaylistItem({event, query}) {
  return (
      <Link
          to={`/playlists/${event.event_id}`}
          className="PlaylistItemLink"
          state={{query}}
      >
        <PlaylistItemDOW>
          {moment(event.event_local_datetime).format('dddd')}
        </PlaylistItemDOW>
        <PlaylistItemDate>
          {moment(event.event_local_datetime).format('YYYY/MM/DD HH:mm')}
        </PlaylistItemDate>
        <PlaylistRoomLabel>Room / floor</PlaylistRoomLabel>
        <PlaylistRoom>{event.floor_name || ''}</PlaylistRoom>
        {
          event.has_tracks ? '' : <NoTracksLabel>No track</NoTracksLabel>
        }
      </Link>
  );
}

export default function PlaylistsPage() {
  const app = useApp();
  const location = useLocation();
  const {errorDialogWithAPIError} = useCustomDialog();
  const [serchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState({
    events: [],
    total: 0,
    page: -1,
    asc: 0,
  });
  let requestedQuery = {
    page: 1,
    asc: 0,
  };

  if (location.search) {
    const pageStr = serchParams.get('page') || '1';
    if (/^[0-9]+$/.test(pageStr)) {
      requestedQuery.page = Math.max(parseInt(pageStr, 10), 1);
    }
    const ascStr = serchParams.get('asc') || '0';
    if (/^[0-1]+$/.test(ascStr)) {
      requestedQuery.asc = parseInt(ascStr, 10);
    }
  }
  useEffect(() => {
    app.showHeader();
    document.title = 'Playlists';
  }, []);

  useEffect(() => {
    let detached = false;
    (async (page, asc) => {
      if (detached) {
        return;
      }
      console.log(page, asc);
      try {
        window.incrementLoading();
        let {events, total} = await getMyEvents({
          offset: (page - 1) * ITEMS_PER_PAGE,
          limit: ITEMS_PER_PAGE,
          asc,
        });
        window.decrementLoading();
        setData({
          events,
          total,
          page,
          asc,
        });
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        if (!detached) {
          await errorDialogWithAPIError(e);
          setData({
            events: [],
            total: 0,
            page,
            asc,
          });
        }
      }
    })(requestedQuery.page, requestedQuery.asc);

    return () => {
      detached = true;
    };
  }, [requestedQuery.page, requestedQuery.asc]);

  const onASCPullDownChange = (newValue) => {
    if (newValue != requestedQuery.asc) {
      setSearchParams(
          {
            page: 0,
            asc: newValue,
          },
          {
            replace: false,
          },
      );
    }
  };

  return (
      <Page>
        <PageFeatureTitle>
          <h2>Playlists</h2>
          <div>
          <span>
            Please don't publish playlists – they're confidential and should only be used internally at your venue.
          </span>
          </div>
        </PageFeatureTitle>

        <ListTopArea>
          <h3></h3>
          <DBDPullDown
              value={requestedQuery.asc}
              onChange={onASCPullDownChange}
              titleLabel="Sort"
              items={[
                {
                  value: 1,
                  label: 'Ascending',
                },
                {
                  value: 0,
                  label: 'Descending',
                },
              ]}
              style={{
                minWidth: 120,
              }}
          ></DBDPullDown>
        </ListTopArea>

        {requestedQuery.page == data.page && requestedQuery.asc == data.asc ? (
            data.events.length ? (
                <>
                  <PlaylistsArea>
                    {data.events.map((event, i) => {
                      return (
                          <PlaylistItem key={i} event={event}
                                        query={requestedQuery}/>
                      );
                    })}
                  </PlaylistsArea>
                  <PlaylistsPagenation data={data} query={requestedQuery}/>
                </>
            ) : (
                <NotFoundMessage>No playlist to display.</NotFoundMessage>
            )
        ) : (
            ''
        )}
      </Page>
  );
}
